import { useContext, useEffect, useState, useCallback } from 'react';
import usePlanServiceApi from 'hooks/usePlanServiceApi';
import catchCancel from 'helpers/catchCancel';
import { parseServerError } from 'helpers/errorHelpers';
import { Context } from 'components/Store';
import {
  PLANS_LIST_V2,
  PLANS_LIST_V2_BY_ORG,
  PLAN_DELETE_V2,
  PLAN_DELETE_V2_BY_ORG
} from 'constants/planServiceV2Flags';

const usePlansData = () => {
  const listApi = usePlanServiceApi(
    'plans',
    PLANS_LIST_V2,
    PLANS_LIST_V2_BY_ORG
  );
  const deleteApi = usePlanServiceApi(
    'plan',
    PLAN_DELETE_V2,
    PLAN_DELETE_V2_BY_ORG
  );
  const [, dispatch] = useContext(Context);
  const [plans, setPlans] = useState({});
  const [loading, setLoading] = useState(true);
  // const orgID = Context?._currentValue[0]?.organization?.id;
  const loadPlans = useCallback(() => {
    const { promise, cancel } = listApi.fetch();
    promise
      .then(({ data }) => {
        setPlans(data.results);
      })
      .catch(catchCancel)
      .catch(err => {
        parseServerError(dispatch)(err);
      })
      .finally(() => setLoading(false));

    return cancel;
  }, [dispatch, listApi]);

  useEffect(() => {
    const cancel = loadPlans();

    return () => {
      cancel();
    };
  }, [loadPlans]);

  const deletePlan = useCallback(
    plan => deleteApi.delete(plan._id).promise.then(loadPlans),
    [deleteApi, loadPlans]
  );

  return {
    plans,
    loading,
    loadPlans,
    deletePlan
  };
};

export default usePlansData;
